/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

export const buildDealer = dealer => {

    if (dealer.account === '' || (dealer.account === null && dealer.name === null && dealer.location === null)) {

        return '---';

    }
    const dealerName = dealer.name ? dealer.name : '';
    const dealerAccount = dealer.account ? dealer.account : '';
    let dealerCity,
        dealerState;

    dealerCity = '';
    dealerState = '';

    if (dealer.location) {

        dealerCity = dealer.location.city ? dealer.location.city : '';
        dealerState = dealer.location.state ? dealer.location.state : '';

    }

    return `${dealerName} - ${dealerAccount} - ${dealerCity}, ${dealerState}`;

};

export const distanceConversion = distanceMiles => {

    if (distanceMiles !== null) {

        const kilometer = 1.60934;
        const calculatedDistance = distanceMiles * kilometer;

        return `${distanceMiles} Miles (${Math.trunc(calculatedDistance)} KM)`;

    }
    return '-';

};

export const buildDealerRecommendationPayload = (facets, pageno, pagesize) => ({
    accounts: facets.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    page: pageno,
    size: pagesize
});

export const buildDealerRecommendationCountPayload = (selectedDealers, pageno, pagesize) => ({
    accounts: selectedDealers.map(dealer => dealer.account),
    page: pageno,
    size: pagesize
});

export const buildDealerRecommendationExcelPayload = (facets, exportToExcel, language) => ({
    accounts: facets.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    export: exportToExcel,
    language
});

export const buildTransferAllDealerRecommendationPayload = (facets, requestedBy, commentsDealerRecommendation, status) => ({
    accounts: facets.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    reasonForChange: commentsDealerRecommendation,
    requestedBy,
    status
});

export const buildDealerRecommendationFilterPayload = (selectedDealers, inputSearchKey, inputSearchType) => ({
    accounts: selectedDealers.map(dealer => dealer.account),
    searchKey: inputSearchKey,
    searchType: inputSearchType
});



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/services/dealer-recommendation-helper.js